import { FileTextIcon, FileIcon, TableIcon } from "lucide-react";
import { MaterializationType } from "@/apollo/types";

import classNames from "@/helpers/classNames";

type ModelIconProps = {
  type?: MaterializationType;
  isDraft?: boolean;
} & React.ComponentProps<typeof FileIcon>;

const ModelSVGIcon = ({
  type,
  className,
  isDraft,
  ...svgProps
}: ModelIconProps) => {
  const Icon = isDraft
    ? FileIcon
    : type === MaterializationType.Table
      ? TableIcon
      : FileTextIcon;
  return <Icon className={classNames("shrink-0", className)} {...svgProps} />;
};

export default ModelSVGIcon;
